import React, { useState } from "react";
import { Instagram, Youtube, Mail, Music2, Twitter } from "lucide-react";
import { SOCIALS, ARTIST } from "../mock";
import { fbTrack } from "../lib/track";

const iconFor = (key, size = 20) => {
  switch (key) {
    case "instagram":
      return <Instagram size={size} />;
    case "youtube":
      return <Youtube size={size} />;
    case "tiktok":
      return <Music2 size={size} />;
    case "x":
      return <Twitter size={size} />;
    default:
      return null;
  }
};

const Connect = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    const subs = JSON.parse(localStorage.getItem("jc_subs") || "[]");
    subs.push({ email, at: new Date().toISOString() });
    localStorage.setItem("jc_subs", JSON.stringify(subs));
    fbTrack("Lead", { content_name: "Email Signup", content_category: "Newsletter" });
    setDone(true);
    setEmail("");
  };

  return (
    <section id="connect" className="relative bg-gradient-to-b from-[#0a0410] via-[#150826] to-[#0a0410] py-24 md:py-32">
      <div className="max-w-[800px] mx-auto px-6 text-center">
        <p className="text-[#c9a24a] tracking-[0.3em] uppercase text-xs mb-3">Join The Movement</p>
        <h2 className="heading-display gold-text text-4xl md:text-6xl mb-10">STAY CONNECTED</h2>

        {/* Socials */}
        <div className="flex justify-center gap-5 mb-12">
          {SOCIALS.map((s) => (
            <a
              key={s.key}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="flex items-center justify-center w-12 h-12 rounded-full border border-[#d4af37]/40 text-[#e8c65a] hover:bg-[#d4af37] hover:text-[#2a0e47] hover:border-[#d4af37] transition-all duration-300 hover:-translate-y-1"
            >
              {iconFor(s.key)}
            </a>
          ))}
        </div>

        {/* Email signup */}
        {done ? (
          <div className="max-w-md mx-auto py-8 border border-[#d4af37]/30 rounded-lg">
            <p className="text-[#e8c65a] text-lg font-medium">Welcome to the movement!</p>
            <p className="text-neutral-400 text-sm mt-2">You are now part of the court.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="max-w-md mx-auto flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Join the movement"
              className="flex-1 bg-white/5 border border-[#d4af37]/20 focus:border-[#d4af37] rounded-sm px-5 py-4 text-white placeholder:text-neutral-500 outline-none transition-colors"
            />
            <button
              type="submit"
              className="px-8 py-4 text-sm tracking-[0.18em] uppercase font-semibold text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] rounded-sm hover:from-[#ffe38f] hover:to-[#d4af37] transition-all duration-300"
            >
              Sign Up
            </button>
          </form>
        )}

        <a
          href={`mailto:${ARTIST.contactEmail}`}
          className="inline-flex items-center gap-2 mt-10 text-neutral-300 hover:text-[#e8c65a] transition-colors"
        >
          <Mail size={16} /> {ARTIST.contactEmail}
        </a>
      </div>
    </section>
  );
};

export default Connect;
